import React from 'react';
import { motion } from 'framer-motion';
import { Email } from '../../types/api';

interface EmailCardProps {
  email: Email;
  isFirst?: boolean;
  isLast?: boolean;
}

export const EmailCard: React.FC<EmailCardProps> = ({
  email,
  isFirst = false,
  isLast = false
}) => {
  const date = new Date(email.timestamp);
  const timeStr = date.toLocaleTimeString('es-CL', {
    hour: '2-digit',
    minute: '2-digit'
  });
  const dateStr = date.toLocaleDateString('es-CL', {
    month: 'short',
    day: 'numeric'
  });

  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94]
      }}
      className={`flex flex-col border-b border-border last:border-b-0 ${
        isFirst ? 'pt-3' : 'pt-4'
      } ${isLast ? 'pb-3' : 'pb-4'} px-4`}
    >
      {/* Sender Badge + From/To + Timestamp (single row on desktop, 2 rows on mobile) */}
      <div className="flex items-start justify-between gap-3 mb-3 w-full">
        <div className="flex items-center gap-2 min-w-0">
          <span className={`shrink-0 text-xs font-medium px-2 py-1 rounded whitespace-nowrap ${
            email.isInbound
              ? 'bg-blue-50 text-blue-700'
              : 'bg-green-50 text-green-700'
          }`}>
            {email.isInbound ? 'Recibido' : 'Enviado'}
          </span>
          <p className="text-sm font-normal text-text truncate">
            {email.isInbound ? email.from : email.to}
          </p>
        </div>
        <div className="shrink-0 text-right">
          <p className="text-xs text-text-subtle leading-tight">{timeStr}</p>
          <p className="text-xs text-text-subtle leading-tight">{dateStr}</p>
        </div>
      </div>

      {/* Subject - prominent if present */}
      {email.subject && (
        <p className="text-sm font-semibold text-text mb-3 leading-snug">
          {email.subject}
        </p>
      )}

      {/* Body - simple text container, no extra background noise */}
      <p className="text-sm text-text-subtle leading-relaxed line-clamp-2 whitespace-pre-wrap">
        {email.body.substring(0, 300)}
      </p>
    </motion.div>
  );
};

export default EmailCard;
